import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { collections as collectionsApi } from '../api';
import './Landing.css';

const Landing = () => {
  const [collection, setCollection] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    collectionsApi.getAll().then(data => {
      if (data.collections.length) setCollection(data.collections[0]);
    });
  }, []);

  return (
    <div className="landing">
      <nav className="nav">
        <div className="nav-content">
          <h1 className="logo">C3</h1>
          <div className="nav-links">
            {user ? (
              <Link to="/dashboard" className="btn-primary">Dashboard</Link>
            ) : (
              <>
                <Link to="/login" className="nav-link">Login</Link>
                <Link to="/register" className="btn-primary">Get Started</Link>
              </>
            )}
          </div>
        </div>
      </nav>

      <section className="hero">
        <h1 className="hero-title">Master Cloud Certifications with Flashcards</h1>
        <p className="hero-subtitle">Learn faster with expertly crafted flashcards designed for AWS, Azure, and Google Cloud certifications</p>
        <Link to="/register" className="btn-hero">Start Learning Today</Link>
      </section>

      {collection && (
        <section className="featured">
          <h2 className="section-title">Featured Collection</h2>
          <div className="collection-card">
            <h3 className="collection-title">{collection.title}</h3>
            <p className="collection-description">{collection.description}</p>
            <div className="collection-meta">
              <span>{collection.totalCards} cards</span>
              <span>{collection.domains.length} domains</span>
              <span className="price">${(collection.price / 100).toFixed(2)}</span>
            </div>
            <Link to={`/collection/${collection.collectionId}`} className="btn-primary">View Collection</Link>
          </div>
        </section>
      )}

      <section className="features">
        <h2 className="section-title">Why C3?</h2>
        <div className="features-grid">
          <div className="feature"><h3>Expert Content</h3><p>Created by certified cloud professionals</p></div>
          <div className="feature"><h3>Adaptive Learning</h3><p>Focus on concepts you find challenging</p></div>
          <div className="feature"><h3>Track Progress</h3><p>Monitor your mastery across all domains</p></div>
        </div>
      </section>
    </div>
  );
};

export default Landing;
